import { connect } from 'react-redux'
import CreateCompanyInfo from '../components/create-company-info';
import { showSubmitMod } from '../action-creators/create-comp-info';
import { closeSubmitMod } from '../action-creators/create-comp-info';

const mapDispatchToProps = (dispatch, props) => ({
    showSubmitModal: () => dispatch(showSubmitMod('')),
    closeSubmitModal: () => dispatch(closeSubmitMod(''))
});

const mapStateToProps = (state) => {
    console.log(`mapStateToProps -> ${JSON.stringify(state.modaldata)}`);
    return {
        modValue: state.modaldata.modValue
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CreateCompanyInfo);